import { PopupModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader';
import React from 'react'
import { changeStatusSubSubCategoryApi } from 'services/subCategory';
import { toastMessage } from 'utils/toastMessage';

const ChangeStatusSubSubCategory = ({ show, close, data, setState }) => {
    const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
    const status = data.status === "ACTIVE" ? "Block" : "Unblock"
    // console.log("it is selected Token status:--------", data);

    const changeStatusHandler = async () => {
        try {
            setButtonLoader(true);
            const reqData = {
                id: data?._id || "",
                status:
                    data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
            };

            const {
                data: { code, message },
            } = await changeStatusSubSubCategoryApi(reqData);
            if (code === 200) {
                setState((prev) =>
                    prev.map((item) =>
                        item._id === data._id ? { ...item, status: reqData.status } : item
                    )
                );
                close();
                toastMessage(message, "success", "changeUserStatusSubSubCategory");
            }
        } catch (e) {
            console.log("error:", e.error);
        } finally {
            setButtonLoader(false);
        }
    };
    return (
        <PopupModal
            show={show}
            handleClose={close}
            content={`Are You Sure , You Want To ${status} This Category?`}
            title="Change Status Category"
            buttonLoader={buttonLoader}
            action={changeStatusHandler}
        />
    )
}

export default ChangeStatusSubSubCategory